import React from 'react';

import PageLayout from '../../layout/PageLayout';
import ZakupRosneftContent from '../../layout/ZakupRosneftContent';

const ZakupRosneftContentPage = () => (
    <PageLayout>
        <ZakupRosneftContent />
    </PageLayout>
);

export default ZakupRosneftContentPage;
